module.exports = __webpack_public_path__ + "assets/img/mecha-btn-5cf268fe.png";